function focusLandingDetail(unitName: string, studentCount: number): string {
  const noun = studentCount === 1 ? 'student' : 'students';
  return `${studentCount} ${noun} will land in Unit ${unitName} when they next log in`;
}

export function buildFocusActivatedMessage(
  unitName: string,
  studentCount: number,
): { summary: string; detail: string } {
  return { summary: `Focus active for Unit ${unitName}`, detail: focusLandingDetail(unitName, studentCount) };
}

export function buildFocusMovedMessage(unitName: string, studentCount: number): { summary: string; detail: string } {
  return { summary: `Focus moved to Unit ${unitName}`, detail: focusLandingDetail(unitName, studentCount) };
}

export function buildFocusEndedMessage(scopeLabel: string): { summary: string; detail: string } {
  return {
    summary: `Focus ended for ${scopeLabel}`,
    detail: "Students go back to finish skills they haven't completed yet",
  };
}
